/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=1c465c46&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=1c465c46&lang=css"

import exportComponent from "/Users/lihe/projects/WebstormProjects/Eazable-visitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__